import { type Static, Type } from '@sinclair/typebox';
import { TierDTOSchema } from '../dto/tier.dto.js';
import { UserDTOSchema } from '../dto/user.dto.js';

// =====================================================================================================================
// Create user with invitation code
// =====================================================================================================================

export const CreateUserWithInvitationBodySchema = Type.Array(
  Type.Object({
    feedUrl: Type.String(),
    tiers: Type.Array(Type.Pick(TierDTOSchema, ['benefits', 'description', 'title', 'amount', 'state'])),
  }),
);
export type CreateUserWithInvitationBody = Static<typeof CreateUserWithInvitationBodySchema>;

export const CreateUserWithInvitationReplySchema = UserDTOSchema;
export type CreateUserWithInvitationReply = Static<typeof CreateUserWithInvitationReplySchema>;
